<template>
        <b-card>
		<b-img
			:src="require('@/assets/images/logo/IZIBOX-LOGO.png')"
			center
		/><br>
		<b-carousel
			id="carousel-example-generic"
			controls
			indicators
			background="#ababab"
			style="text-shadow: 1px 1px 2px #333;"
		>
			<b-carousel-slide :img-src="require('@/assets/images/illustration/izibox.jpg')" />
			<b-carousel-slide :img-src="require('@/assets/images/illustration/izibox.jpg')" />
		</b-carousel><br>
			<b-card-text>
				<div class="text-center" ><div class="badge badge-primary" >Bienvenue chez IZIBOX Self Stockage.</div></div><br>
				Que vous soyez un particulier ou un professionnel, il existe une taille de box faite pour vous. <br>
				Faites votre sélection ! IZIBOX vous propose un large choix d’espace de 2m2 à 28m2.<br><br>
				<div class="text-center" ><strong>Kass pu la tête, Adopt un Box ! 😀</strong></div>
			</b-card-text>
			<b-button
			block
			Primary
			@click="openurl('https://www.izibox.re/')"
			>
			Visiter le site
			</b-button>
        </b-card>
</template>

<script>
import {
  BCard, BCardText, BButton, BImg, BCarousel, BCarouselSlide,
} from 'bootstrap-vue'
	
export default {
	components: {
		BCard,
		BCardText,
		BButton,
		BImg,
		BCarousel,
		BCarouselSlide,
	},
}
</script>
